// Content Approval Action Types

// Fetch Pending Contents
export const FETCH_PENDING_CONTENTS_REQUEST = "FETCH_PENDING_CONTENTS_REQUEST";
export const FETCH_PENDING_CONTENTS_SUCCESS = "FETCH_PENDING_CONTENTS_SUCCESS";
export const FETCH_PENDING_CONTENTS_FAILURE = "FETCH_PENDING_CONTENTS_FAILURE";

// Approve Content
export const APPROVE_CONTENT_REQUEST = "APPROVE_CONTENT_REQUEST";
export const APPROVE_CONTENT_SUCCESS = "APPROVE_CONTENT_SUCCESS";
export const APPROVE_CONTENT_FAILURE = "APPROVE_CONTENT_FAILURE";

// Reject Content
export const REJECT_CONTENT_REQUEST = "REJECT_CONTENT_REQUEST";
export const REJECT_CONTENT_SUCCESS = "REJECT_CONTENT_SUCCESS";
export const REJECT_CONTENT_FAILURE = "REJECT_CONTENT_FAILURE";

// Filters and UI
export const SET_CONTENT_APPROVAL_FILTERS = "SET_CONTENT_APPROVAL_FILTERS";
export const CLEAR_CONTENT_APPROVAL_ERROR = "CLEAR_CONTENT_APPROVAL_ERROR";
export const RESET_CONTENT_APPROVAL_STATE = "RESET_CONTENT_APPROVAL_STATE";
